import React from "react";
import {Button} from "@material-ui/core";
import C from './../../Constants';
import "./LoginPanel.css"
import {withStyles} from "@material-ui/core/styles";
import Password from "../elements/Password";
import PropTypes from 'prop-types';
import Helper from "../../Utils";
import YouTube from "../elements/Youtube";
import DatePicker from "./DaySelector";
import Resize from 'react-resize-to-aspect-ratio';
import {Scrollbars} from "react-custom-scrollbars";

const styles = theme => ({
    loginPanel: {
        paddingLeft: theme.spacing.unit * 4,
        paddingRight: theme.spacing.unit * 4,
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    errorText: {
        color: theme.palette.error,
    },
    loginButton: {
        width: "100%",
        marginTop: theme.spacing.unit * 3,
    },
    password: {
        width: "100%",
        marginTop: theme.spacing.unit * 2,
    },
    introImage: {
        width: "300px",
    }
});

class PrayerAppbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            passwordError: false,
            password: "",
            showPassword: false,
        };
    }

    render() {
        const {classes} = this.props;
        return <Scrollbars autoHide>
            <div className={classes.loginPanel}>
                <div id="loginPanelGroupSelect">

                    {!this.groupExisting() || this.props.groupData.groupName == "" ?
                        <img className={classes.introImage} src={Helper.getResource("nothingSelected.png")}/> : null}

                    {this.groupExisting() && this.props.groupData.groupName !== "" ?
                        <DatePicker loginData={this.props.loginData} groupData={this.props.groupData} loginPanel={this}
                                    displayedMonth={this.props.displayedMonth}
                                    selectedDate={this.props.selectedDate}/> : null}

                    {this.hasPassword() ? <Password
                        error={this.state.passwordError}
                        className={classes.password}
                        valueCallback={this.handleChange('password')}
                        fullWidth
                        onEnter={this.loginUser}/> : null}

                    {this.groupExisting() && this.props.groupData.groupName !== "" ?
                        <Button
                            variant="raised"
                            className={classes.loginButton}
                            color="secondary"
                            onClick={this.loginUser}>Anmelden</Button> : null}
                </div>
                {this.props.groupData != null && this.props.groupData.youtubeLink != "" && this.props.groupData.youtubeLink != null &&
                    this.msiVersion() == null ? <div className={classes.youtubePlayer} id="youtubePlayer"><Resize aspectRatio="16:9">
                        <YouTube videoId={this.props.groupData.youtubeLink}
                                 opts={{playerVars: {autoplay: 0}, height: "100%", width: "100%"}}/>
                    </Resize></div> : null}
            </div>
        </Scrollbars>;
    }

    groupExisting = () => this.props.groupNames.indexOf(this.props.groupData.groupName) >= 0;
    handleChange = key => value => this.setState({[key]: value});
    hasPassword = () => this.props.groupData.groupHasPassword;
    hasGroupName = () => this.props.groupData.groupName !== "" && this.props.groupData.groupName != null;
    loginUser = () => {
        const that = this;
        this.props.app.serverCommunication.serverLoginToHourPanelView(this.state.password,
            (data) => {
                that.setState({passwordError: !data.isGroupUser});
            });
        this.setState({passwordError: false});

    };
    displayMonth = month => this.props.app.changeDisplayMonth(month);
    dateSelected = (date) => this.props.app.changeSelectedDate(date);
    addDate = (date) => this.props.app.serverCommunication.serverInsertHour(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), -1, "day created", "", C.hourTypeNameToIdMapping[C.HOUR_TYPE_BLOCKED], 0);
    removeDate = (date) => this.props.app.serverCommunication.serverDeleteHourAllEntries(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), -1);
    msiVersion = () => {
        let ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        return null;
    }
}

PrayerAppbar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrayerAppbar);
